import type { FC } from 'react';
import styles from './index.module.css';

const ArrowUp: FC = () => {
  return <div className={styles.arrowUp} />;
};

export default ArrowUp;
